export function validateCommentText(text) {
    text = (text || "").trim();
    if (!text) {
        return { valid: false };
    } else if (text.length >= 2000) {
        return {
            valid: false,
            error: "Comments must be less than 2000 characters."
        };
    }
    return { valid: true };
}



// WEBPACK FOOTER //
// ./src/utils/validation.js